const UUID_SUFFIX_PATTERN = /^(.*)-([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$/i;

export function slugifySegment(value: string): string {
  return value
    .toLowerCase()
    .trim()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-')
    || 'item';
}

export function parseSlugAndId(value: string): { slug: string; id: string } | null {
  const match = value.match(UUID_SUFFIX_PATTERN);
  if (!match) return null;
  return {
    slug: match[1] || '',
    id: match[2],
  };
}

/**
 * Strip "Lesson 76:", "Section 12-2:", "Unit 3:" prefixes from lesson titles
 * so page titles lead with the actual topic for better search intent matching.
 */
export function stripLessonPrefix(title: string): string {
  return title.replace(/^(?:lesson|section|unit)\s+[\d\-.]+[:\s]+/i, '').trim() || title;
}

export function buildPublicLearnHref(title: string, lessonId: string): string {
  return `/learn/${slugifySegment(title)}-${lessonId}`;
}

export function buildPublicSkillLearnHref(title: string, skillId: string): string {
  return `/learn/skills/${slugifySegment(title)}-${skillId}`;
}

export function buildPublicPracticeHref(
  title: string,
  lessonId: string,
  mode?: 'problemSet' | 'challenge',
): string {
  const basePath = `/practice/${slugifySegment(title)}-${lessonId}`;
  if (mode === 'problemSet') {
    return `${basePath}/problem-set`;
  }
  if (mode === 'challenge') {
    return `${basePath}/challenge`;
  }
  return basePath;
}

export function buildPublicSkillPracticeHref(
  title: string,
  skillId: string,
  mode?: 'challenge',
): string {
  const basePath = `/practice/skills/${slugifySegment(title)}-${skillId}`;
  if (mode === 'challenge') {
    return `${basePath}/challenge`;
  }
  return basePath;
}

export function buildTextbookSearchHref(title: string, questId: string): string {
  return `/search/textbooks/${slugifySegment(title)}-${questId}`;
}
